import React from "react";
import AllRoutes from "./router/AllRoutes";

const App = () => {
  return (
    <>
      <AllRoutes />
    </>
  );
};

export default App;
